import { useEffect } from 'react';
import { useSetAtom } from 'jotai';
import type { GetFeatureFlagFunctionT } from '../../../common/providers/feature-flag-provider';
import { FEATURE_FLAGS } from '../../labelling/constants';
import { accurateFrameRenderingAtom } from '../atoms/video-playback-atoms';
export function AccurateFrameRenderingFlagSync({
  getFeatureFlag
}: {
  getFeatureFlag?: GetFeatureFlagFunctionT;
}) {
  const setFlag = useSetAtom(accurateFrameRenderingAtom);
  useEffect(() => {
    if (!getFeatureFlag) {
      setFlag(false);
      return;
    }
    getFeatureFlag(FEATURE_FLAGS.ENABLE_ACCURATE_FRAME_RENDERING).then(result => {
      setFlag('enabled' in result && result.enabled);
    }).catch(() => {
      setFlag(false);
    });
  }, [getFeatureFlag, setFlag]);
  return null;
}